import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { useSelector } from 'react-redux'
import { useMemo } from 'react'
import { getTheme } from '../theme'

const AppThemeProvider = ({ children }) => {
  const themeMode = useSelector(state => state.theme.mode)

  const theme = useMemo(() => {
    return getTheme(themeMode)
  }, [themeMode])

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}

export default AppThemeProvider
